import React, { Component } from 'react';

class SelectSheet extends Component {
    render() {
        return (
            <li className="sheet-component-container select-box-wrap">
                <button type="button" className="btn exam-bnt">{this.props.examNum}</button>
                <form>
                    <div>
                        <label for="sheet-num1"><input type="checkbox" id="sheet-num1" name="chk" /><span className="select-box d-inline-block selected">1</span></label>
                        <label for="sheet-num1"><input type="checkbox" id="sheet-num2" name="chk" /><span className="select-box d-inline-block">1</span></label>
                    </div>
                </form>
            </li>
            
        );
    }
}

export default SelectSheet;